import { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

/**
* Render a themed heatmap skeleton composed of animated placeholder blocks.
* @example
* HeatmapSkeleton()
* <div className="rounded-lg p-6">...</div>
* @returns {{JSX.Element}} A React element representing the heatmap loading skeleton.
**/
const HeatmapSkeleton = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div 
      className="rounded-lg p-6"
      style={{ 
        backgroundColor: theme.background.card,
        boxShadow: theme.shadow.md
      }}
    >
      {/* Header */}
      <div 
        className="h-6 rounded w-64 mb-4 animate-pulse"
        style={{ backgroundColor: theme.background.secondary }}
      />

      {/* Month labels */}
      <div className="flex gap-2 mb-2">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => (
          <div 
            key={i}
            className="h-3 rounded w-8 animate-pulse"
            style={{ backgroundColor: theme.background.secondary }}
          />
        ))}
      </div>

      {/* Heatmap grid */}
      <div className="mb-4">
        <div 
          className="h-32 rounded animate-pulse"
          style={{ backgroundColor: theme.background.secondary }}
        />
      </div>

      {/* Footer stats */}
      <div className="flex gap-6 justify-center">
        {[1, 2, 3].map(i => (
          <div key={i} className="text-center">
            <div 
              className="h-4 rounded w-24 mb-1 animate-pulse"
              style={{ backgroundColor: theme.background.secondary }}
            />
            <div 
              className="h-6 rounded w-16 mx-auto animate-pulse"
              style={{ backgroundColor: theme.background.secondary }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeatmapSkeleton;
